<script setup lang="ts">
interface CustomShirtFigureProps {
	armHoleHighlighted: boolean;
	hipHighlighted: boolean;
	waistHighlighted: boolean;
	chestHighlighted: boolean;
	bottomHighlighted: boolean;
	shoulderHighlighted: boolean;
	lengthHighlighted: boolean;
	sleeveHighlighted: boolean;
	wristHighlighted: boolean;

	customShirt: {
		[key: string]: string;
	};
}
const props = defineProps<CustomShirtFigureProps>();
</script>

<template>
	<div
		class="size-chart__custom-shirt-figure mb-xl size-figures bg-gray-50 gap-xs p-xs flex justify-center rounded"
	>
		<div class="lg:hidden component--shirtfigure-mobile block">
			<svg
				width="310"
				height="508"
				viewBox="0 0 310 508"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<rect width="309.458" height="508" rx="8" fill="#F6F6F6" />
				<!-- shirt outline -->
				<path
					d="M161.707 470.455C108.745 470.455 69.1655 460.489 55.9961 455.506C55.9961 441.625 62.4028 415.998 74.1485 374.354C85.8942 332.71 94.4365 247.287 95.5043 216.321C96.3585 191.548 93.7246 137.661 92.3009 113.813C104.26 112.105 101.555 70.3899 98.7077 49.7459C105.542 48.0375 119.352 47.6104 125.402 47.6104C125.046 59.0001 130.741 81.7796 156.368 81.7796C188.402 81.7796 189.47 54.0171 189.47 47.6104C195.521 47.6104 209.331 48.0375 216.164 49.7459C213.317 70.3899 210.612 112.105 222.571 113.813C221.147 137.661 218.514 191.548 219.368 216.321C220.436 247.287 228.978 332.71 240.724 374.354C252.469 415.998 258.876 441.625 258.876 455.506C245.707 460.489 206.127 470.455 153.165 470.455"
					stroke="#868686"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<!-- Left arm outline -->
				<path
					d="M78.3964 71.1019C88.0065 53.0828 98.6844 49.7461 98.6844 49.7461C101.126 66.835 105.091 111.678 92.2776 113.813V121.288L50.6339 248.355C30.3459 247.287 22.8713 239.813 19.668 235.541C19.668 235.541 72.132 82.8476 78.3964 71.1019Z"
					stroke="#868686"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<!-- rigth arm outline -->
				<path
					d="M236.85 71.1019C227.24 53.0828 216.562 49.7461 216.562 49.7461C214.12 66.835 210.155 111.678 222.968 113.813V121.288L264.612 248.355C284.9 247.287 292.375 239.813 295.578 235.541C295.578 235.541 243.114 82.8476 236.85 71.1019Z"
					stroke="#868686"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>

				<g v-show="props.armHoleHighlighted === true">
					<!-- right shoulder -->
					<path
						d="M209.656 49.7461C207.214 66.835 203.249 111.678 216.062 113.813"
						stroke="#EA0000"
						stroke-width="0.75"
						stroke-linejoin="round"
					/>
					<!-- left shoulder -->
					<path
						d="M105.922 49.7461C108.364 66.835 112.329 111.678 99.5156 113.813"
						stroke="#EA0000"
						stroke-width="0.75"
						stroke-linejoin="round"
					/>

					<rect
						id="rct_armHole"
						x="140.809"
						y="70"
						height="26"
						rx="13"
						fill="#EA0000"
					/>
					<text
						id="txt_armHole"
						x="147"
						y="88"
						fill="white"
						class="text-base font-semibold"
					>
						{{ props.customShirt['Shirt Arm Hole'] }}
					</text>
				</g>
				<g v-show="props.armHoleHighlighted === false">
					<!-- right shoulder -->
					<path
						d="M209.656 49.7461C207.214 66.835 203.249 111.678 216.062 113.813"
						stroke="#888888"
						stroke-width="0.5"
						stroke-linejoin="round"
						stroke-dasharray="3 3"
					/>
					<!-- left shoulder -->
					<path
						d="M105.922 49.7461C108.364 66.835 112.329 111.678 99.5156 113.813"
						stroke="#888888"
						stroke-width="0.5"
						stroke-linejoin="round"
						stroke-dasharray="3 3"
					/>
				</g>

				<!-- hip -->
				<g v-show="props.hipHighlighted === true">
					<ellipse
						cx="157.486"
						cy="265.359"
						rx="63.7773"
						ry="4.99127"
						stroke="#EA0000"
						stroke-width="0.5"
						stroke-linecap="round"
					/>
					<rect
						id="rct_hip"
						x="140.809"
						y="252"
						height="26"
						rx="13"
						fill="#EA0000"
					/>
					<text
						id="txt_hip"
						x="147"
						y="270"
						fill="white"
						class="text-base font-semibold"
					>
						{{ props.customShirt['Shirt Hip'] }}
					</text>
				</g>
				<g v-show="props.hipHighlighted === false">
					<ellipse
						cx="157.486"
						cy="265.359"
						rx="63.7773"
						ry="4.99127"
						stroke="#888888"
						stroke-width="0.5"
						stroke-linecap="round"
						stroke-dasharray="3 3"
					/>
				</g>

				<!-- waist -->
				<g v-show="props.waistHighlighted === true">
					<ellipse
						cx="157.485"
						cy="216.556"
						rx="60.4498"
						ry="4.99127"
						stroke="#EA0000"
						stroke-width="0.5"
						stroke-linecap="round"
					/>
					<rect
						id="rct_waist"
						x="140.809"
						y="202"
						height="26"
						rx="13"
						fill="#EA0000"
					/>
					<text
						id="txt_waist"
						x="147"
						y="220"
						fill="white"
						class="text-base font-semibold"
					>
						{{ props.customShirt['Shirt Waist'] }}
					</text>
				</g>
				<g v-if="waistHighlighted === false">
					<ellipse
						cx="157.485"
						cy="216.556"
						rx="60.4498"
						ry="4.99127"
						stroke="#888888"
						stroke-width="0.5"
						stroke-linecap="round"
						stroke-dasharray="3 3"
					/>
				</g>

				<!-- chest -->
				<g v-show="props.chestHighlighted === true">
					<ellipse
						cx="157.486"
						cy="115.621"
						rx="63.7773"
						ry="4.99127"
						stroke="#EA0000"
						stroke-width="0.5"
						stroke-linecap="round"
					/>

					<rect
						id="rct_chest"
						x="140.809"
						y="102"
						height="26"
						rx="13"
						fill="#EA0000"
					/>
					<text
						id="txt_chest"
						x="147"
						y="120"
						fill="white"
						class="text-base font-semibold"
					>
						{{ props.customShirt['Shirt Chest'] }}
					</text>
				</g>

				<g v-if="chestHighlighted === false">
					<ellipse
						cx="157.486"
						cy="115.621"
						rx="63.7773"
						ry="4.99127"
						stroke="#888888"
						stroke-width="0.5"
						stroke-linecap="round"
						stroke-dasharray="3 3"
					/>
				</g>

				<!-- bottom/daman -->
				<g v-show="props.bottomHighlighted === true">
					<ellipse
						cx="157.486"
						cy="447.818"
						rx="99.2707"
						ry="17.7467"
						stroke="#EA0000"
						stroke-width="0.5"
						stroke-linecap="round"
					/>
					<rect
						id="rct_bottom"
						x="140.809"
						y="435"
						height="26"
						rx="13"
						fill="#EA0000"
					/>
					<text
						id="txt_bottom"
						x="147"
						y="454"
						fill="white"
						class="text-base font-semibold"
					>
						{{ props.customShirt['Shirt Bottom'] }}
					</text>
				</g>
				<g v-show="props.bottomHighlighted === false">
					<ellipse
						cx="157.486"
						cy="447.818"
						rx="99.2707"
						ry="17.7467"
						stroke="#888888"
						stroke-width="0.5"
						stroke-linecap="round"
						stroke-dasharray="3 3"
					/>
				</g>

				<!-- across shoulder when highlighted -->
				<g v-show="props.shoulderHighlighted === true">
					<path d="M97.3086 38.0898L218.503 37.5559" stroke="#EA0000" />

					<rect
						id="rct_shoulder"
						x="140.809"
						y="24"
						height="26"
						rx="13"
						fill="#EA0000"
					/>
					<text
						id="txt_shoulder"
						x="147"
						y="42"
						fill="white"
						class="text-base font-semibold"
					>
						{{ props.customShirt['Shirt Shoulder'] }}
					</text>
				</g>

				<g v-if="shoulderHighlighted === false">
					<path
						d="M97.0352 38.5342L218.229 38.0003"
						stroke="#888888"
						stroke-width="0.5"
						stroke-dasharray="3 3"
					/>
				</g>

				<!-- shirt length highlighted  -->
				<g v-show="props.lengthHighlighted === true">
					<path d="M157.582 470L157.582 40.7488" stroke="#EA0000" />
					<rect
						id="rct_length"
						x="135.654"
						y="157"
						height="26"
						rx="13"
						fill="#EA0000"
					/>
					<text
						id="txt_length"
						x="147"
						y="175"
						fill="white"
						class="text-base font-semibold"
					>
						{{ props.customShirt['Shirt Length'] }}
					</text>
				</g>

				<!-- shirt length -->
				<g v-if="lengthHighlighted === false">
					<path
						d="M156.93 470.455L156.93 41.2038"
						stroke="#888888"
						stroke-width="0.5"
						stroke-dasharray="3 3"
					/>
				</g>

				<!-- sleeve length -->
				<g v-show="props.sleeveHighlighted === true">
					<path
						d="M81.7695 38.4443L13.001 231.44"
						stroke="#EA0000"
						stroke-linejoin="round"
					/>
					<rect
						id="rct_sleeve"
						x="25"
						y="120"
						height="26"
						rx="13"
						fill="#EA0000"
					/>
					<text
						id="txt_sleeve"
						x="25"
						y="138"
						fill="white"
						class="text-base font-semibold"
					>
						{{ props.customShirt['Shirt Sleeve Length'] }}
					</text>
				</g>
				<g v-show="props.sleeveHighlighted === false">
					<path
						d="M81.7695 38.6279L13.001 231.624"
						stroke="#888888"
						stroke-width="0.5"
						stroke-linejoin="round"
						stroke-dasharray="3 3"
					/>
				</g>

				<g v-show="props.wristHighlighted === true">
					<ellipse
						cx="35.9043"
						cy="239.432"
						rx="15.0664"
						ry="2.81554"
						transform="rotate(20.1536 35.9043 239.432)"
						stroke="#EA0000"
						stroke-width="0.5"
						stroke-linecap="round"
					/>
					<!-- right sleeve wrist -->
					<ellipse
						rx="15.0664"
						ry="2.81554"
						transform="matrix(-0.938772 0.344538 0.344538 0.938772 278.783 239.432)"
						stroke="#EA0000"
						stroke-width="0.5"
						stroke-linecap="round"
					/>
					<rect
						id="rct_wrist"
						x="25"
						y="260"
						height="26"
						rx="13"
						fill="#EA0000"
					/>
					<text
						id="txt_wrist"
						x="25"
						y="278"
						fill="white"
						class="text-base font-semibold"
					>
						{{ props.customShirt['Shirt Wrist'] }}
					</text>
				</g>
				<g v-show="props.wristHighlighted === false">
					<!-- left sleeve wrist -->
					<ellipse
						cx="35.9043"
						cy="239.432"
						rx="15.0664"
						ry="2.81554"
						transform="rotate(20.1536 35.9043 239.432)"
						stroke="#888888"
						stroke-width="0.5"
						stroke-linecap="round"
						stroke-dasharray="3 3"
					/>
					<!-- right sleeve wrist -->
					<ellipse
						rx="15.0664"
						ry="2.81554"
						transform="matrix(-0.938772 0.344538 0.344538 0.938772 278.783 239.432)"
						stroke="#888888"
						stroke-width="0.5"
						stroke-linecap="round"
						stroke-dasharray="3 3"
					/>
				</g>
			</svg>
		</div>

		<svg
			class="lg:block component--shirtfigure-desktop hidden"
			width="171"
			height="480"
			viewBox="0 0 171 480"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect width="171" height="508" rx="8" fill="#F6F6F6" />

			<!-- body -->
			<path
				d="M89.1715 373.965C59.9056 373.965 38.0349 368.458 30.7578 365.705C30.7578 358.034 34.298 343.873 40.7884 320.862C47.2788 297.85 51.9991 250.647 52.5892 233.536C53.0612 219.848 51.6058 190.07 50.8191 176.893C57.4275 175.949 55.9327 152.898 54.3593 141.491C58.1355 140.547 65.7667 140.311 69.1102 140.311C68.9135 146.604 72.0604 159.192 86.2213 159.192C103.922 159.192 104.512 143.851 104.512 140.311C107.856 140.311 115.487 140.547 119.263 141.491C117.69 152.898 116.195 175.949 122.804 176.893C122.017 190.07 120.561 219.848 121.033 233.536C121.623 250.647 126.344 297.85 132.834 320.862C139.325 343.873 142.865 358.034 142.865 365.705C135.588 368.458 113.717 373.965 84.4512 373.965"
				stroke="#868686"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<!-- arm -->
			<path
				d="M43.1356 153.291C48.446 143.334 54.3463 141.49 54.3463 141.49C55.6953 150.933 57.8865 175.712 50.8061 176.893V181.023L27.7947 251.237C16.584 250.647 12.4537 246.517 10.6836 244.157C10.6836 244.157 39.6741 159.782 43.1356 153.291Z"
				stroke="#868686"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<!-- arm -->
			<path
				d="M130.693 153.291C125.383 143.334 119.483 141.49 119.483 141.49C118.134 150.933 115.943 175.712 123.023 176.893V181.023L146.034 251.237C157.245 250.647 161.375 246.517 163.146 244.157C163.146 244.157 134.155 159.782 130.693 153.291Z"
				stroke="#868686"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>

			<!-- right wrist -->
			<ellipse
				rx="8.32537"
				ry="1.55581"
				transform="matrix(-0.938772 0.344538 0.344538 0.938772 153.866 246.307)"
				:stroke="wristHighlighted === true ? '#EA0000' : '#888888'"
				:stroke-width="wristHighlighted === true ? '1' : '0.5'"
				stroke-linecap="round"
				:stroke-dasharray="wristHighlighted === true ? 'none' : '3 3'"
			/>
			<!-- left wrist -->
			<ellipse
				cx="19.6556"
				cy="246.307"
				rx="8.32537"
				ry="1.55581"
				transform="rotate(20.1536 19.6556 246.307)"
				:stroke="wristHighlighted === true ? '#EA0000' : '#888888'"
				:stroke-width="wristHighlighted === true ? '1' : '0.5'"
				stroke-linecap="round"
				:stroke-dasharray="wristHighlighted === true ? 'none' : '3 3'"
			/>
			<!-- rigth arm hole -->
			<path
				d="M115.668 141.49C114.319 150.933 112.128 175.712 119.208 176.892"
				:stroke="armHoleHighlighted === true ? '#EA0000' : '#888888'"
				:stroke-width="armHoleHighlighted === true ? '1' : '0.5'"
				stroke-linejoin="round"
				:stroke-dasharray="armHoleHighlighted === true ? 'none' : '3 3'"
			/>
			<!-- left arm hole -->
			<path
				d="M58.3459 141.49C59.6949 150.933 61.8861 175.712 54.8057 176.892"
				:stroke="armHoleHighlighted ? '#EA0000' : '#888888'"
				:stroke-width="armHoleHighlighted === true ? '1' : '0.5'"
				stroke-linejoin="round"
				:stroke-dasharray="armHoleHighlighted === true ? 'none' : '3 3'"
			/>
			<!-- hip -->
			<ellipse
				cx="86.8391"
				cy="260.634"
				rx="35.2419"
				ry="2.75806"
				:stroke="hipHighlighted === true ? '#EA0000' : '#888888'"
				:stroke-width="hipHighlighted === true ? '1' : '0.5'"
				stroke-linecap="round"
				:stroke-dasharray="hipHighlighted === true ? 'none' : '3 3'"
			/>
			<!-- waist -->
			<ellipse
				cx="86.8388"
				cy="233.666"
				rx="33.4032"
				ry="2.75806"
				:stroke="waistHighlighted === true ? '#EA0000' : '#888888'"
				:stroke-width="waistHighlighted === true ? '1' : '0.5'"
				stroke-linecap="round"
				:stroke-dasharray="waistHighlighted === true ? 'none' : '3 3'"
			/>
			<!-- chest -->
			<ellipse
				cx="86.8391"
				cy="177.892"
				rx="35.2419"
				ry="2.75806"
				:stroke="chestHighlighted === true ? '#EA0000' : '#888888'"
				:stroke-width="chestHighlighted === true ? '1' : '0.5'"
				stroke-linecap="round"
				:stroke-dasharray="chestHighlighted === true ? 'none' : '3 3'"
			/>
			<!-- bottom -->
			<ellipse
				cx="86.8387"
				cy="361.457"
				rx="54.8548"
				ry="9.80645"
				:stroke="bottomHighlighted === true ? '#EA0000' : '#888888'"
				:stroke-width="bottomHighlighted === true ? '1' : '0.5'"
				stroke-linecap="round"
				:stroke-dasharray="bottomHighlighted === true ? 'none' : '3 3'"
			/>
			<!-- shoulder -->
			<path
				d="M53.4355 135.295L120.405 135"
				:stroke="shoulderHighlighted === true ? '#EA0000' : '#888888'"
				:stroke-width="shoulderHighlighted === true ? '1' : '0.5'"
				:stroke-dasharray="shoulderHighlighted === true ? 'none' : '3 3'"
			/>

			<!-- shirt length -->
			<path
				d="M86.5317 373.965L86.5317 136.77"
				:stroke="lengthHighlighted === true ? '#EA0000' : '#888888'"
				:stroke-width="lengthHighlighted === true ? '1' : '0.5'"
				:stroke-dasharray="lengthHighlighted === true ? 'none' : '3 3'"
			/>

			<!-- sleeve length -->
			<path
				d="M45 135.347L7 241.992"
				:stroke="sleeveHighlighted === true ? '#EA0000' : '#888888'"
				:stroke-width="sleeveHighlighted === true ? '1' : '0.5'"
				stroke-linejoin="round"
				:stroke-dasharray="sleeveHighlighted === true ? 'none' : '3 3'"
			/>
		</svg>
	</div>
</template>
